const styles = theme => {
  const font = theme.typography.overline || {};
  return {
    root: {
      backgroundColor: theme.palette.background.default,
      padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
      border: `1px solid ${theme.palette.grey[300]}`,
      marginBottom: theme.spacing(3),
      color: theme.palette.grey[600],
      display: 'flex',
      width: '100%',
      ...font,
      '&:hover $hideActionsUntilHover': {
        visibility: 'visible'
      }
    },
    title: {
      width: '14%',
      minWidth: theme.spacing(23.25),
      height: theme.spacing(7),
      display: 'flex',
      alignItems: 'center'
    },
    body: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    actions: {
      marginLeft: 'auto',
      paddingLeft: theme.spacing(2),
      height: theme.spacing(7),
      display: 'flex',
      alignItems: 'center'
    },
    hideActionsUntilHover: {
      visibility: 'hidden'
    },
    icon: {
      cursor: 'pointer'
    }
  };
};
export default styles;
